"use client";
import { useFeatureNavigation } from "./use-feature-navigation";

export function usePathname(): string {
  return useFeatureNavigation().pathname;
}
